import React from 'react';
import { useInView } from 'react-intersection-observer';
import { SERVICES } from '../../data/appData';

const PHONE = '05322114690';
const PHONE_DISPLAY = '0532 211 46 90';

function ServiceCard({ service, index }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <div ref={ref} style={{ background: 'var(--bg-card)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border-color)', padding: '28px', transition: 'all 0.3s cubic-bezier(0.4,0,0.2,1)', position: 'relative', overflow: 'hidden', animation: inView ? `slideInUp 0.5s ${index * 0.08}s both` : 'none' }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-8px) scale(1.01)'; e.currentTarget.style.boxShadow = `0 20px 60px ${service.color}30, var(--shadow-lg)`; e.currentTarget.style.borderColor = service.color + '70'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0) scale(1)'; e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; e.currentTarget.style.borderColor = 'var(--border-color)'; }}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: service.color, borderRadius: 'var(--radius-lg) var(--radius-lg) 0 0' }}/>
      {service.popular && (
        <div style={{ position: 'absolute', top: '16px', right: '16px', padding: '4px 10px', borderRadius: 'var(--radius-full)', background: 'rgba(255,193,7,0.12)', border: '1px solid rgba(255,193,7,0.3)', fontSize: '0.7rem', fontWeight: 700, color: '#ffc107', fontFamily: 'var(--font-mono)', letterSpacing: '0.05em' }}>⭐ POPÜLER</div>
      )}
      <div style={{ width: '56px', height: '56px', borderRadius: '14px', background: service.color + '18', border: `1px solid ${service.color}40`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '26px', marginBottom: '18px', transition: 'all 0.3s', boxShadow: `0 4px 16px ${service.color}20` }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.12) rotate(-4deg)'; e.currentTarget.style.boxShadow = `0 8px 24px ${service.color}50`; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1) rotate(0deg)'; e.currentTarget.style.boxShadow = `0 4px 16px ${service.color}20`; }}
      >{service.icon}</div>
      <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.05rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '10px', paddingRight: service.popular ? '70px' : '0' }}>{service.title}</h3>
      <p style={{ fontSize: '0.88rem', color: 'var(--text-muted)', lineHeight: 1.65, marginBottom: '20px' }}>{service.description}</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '20px' }}>
        {service.features.map(f => (
          <span key={f} style={{ padding: '4px 10px', borderRadius: 'var(--radius-full)', background: 'var(--surface-1)', fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 500 }}>✓ {f}</span>
        ))}
      </div>
      <div style={{ paddingTop: '16px', borderTop: '1px solid var(--border-color)' }}>
        <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: '2px' }}>SÜRE</div>
        <div style={{ fontFamily: 'var(--font-mono)', fontWeight: 700, color: 'var(--text-secondary)', fontSize: '0.85rem' }}>{service.duration}</div>
      </div>
    </div>
  );
}

export default function ServicesSection() {
  const scrollToContact = () => {
    const el = document.getElementById('iletisim');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="section" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">Hizmetlerimiz</div>
          <h2 className="section-title">
            Her Tesisat Sorununuza<br/>
            <span className="gradient-text">Teknolojik Çözüm</span>
          </h2>
          <p className="section-subtitle">
            Gelişmiş ekipmanlar ve deneyimli uzman ekibimizle Ankara'nın her semtine hızlı ve kalıcı tesisat çözümleri sunuyoruz.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '40px' }}>
          {SERVICES.map((service, i) => (
            <div key={service.id} style={{ ...(i === SERVICES.length - 1 && SERVICES.length % 3 !== 0 ? { gridColumn: '2' } : {}), display: 'flex', flexDirection: 'column' }}>
              <ServiceCard service={service} index={i} />
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center' }}>
          <a href={`tel:${PHONE}`} className="btn btn-primary" style={{ fontSize: '1rem', padding: '16px 36px' }}>
            📞 Hemen Arayın: {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}
